import { render } from "./slicePart.vue?vue&type=template&id=31ca7416&scoped=true"
import script from "./slicePart.vue?vue&type=script&lang=js"
export * from "./slicePart.vue?vue&type=script&lang=js"

import "./slicePart.vue?vue&type=style&index=0&id=31ca7416&lang=less&scoped=true"

import exportComponent from "E:\\project\\eyes-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ca7416"]])

export default __exports__